import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router";
import "../headerStyle.css";

interface Props {
  navigationPath: string;
  className?: string;
  buttonWidth?: string;
  isNoChanged?: boolean;
  children: ReactNode;
}

export const HeaderButton = ({
  navigationPath,
  className,
  buttonWidth,
  isNoChanged = false,
  children
}: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <button
      className={`${className} ${buttonWidth ? buttonWidth : "w-full"} header-font h-full border-b border-gray-900 hover:bg-gray-800 ${!isNoChanged && location.pathname === navigationPath ? "bg-gray-900" : ""}`}
      onClick={() => navigate(navigationPath)}
    >
      {children}
    </button>
  );
};
